import { Trans, msg } from '@lingui/macro'
import { Model } from 'jms-domain'

import {
  AttributeListSelector,
  AttributeSwitchSelector,
  useResolveLocalizable,
} from '@salsita-ai/platform-project-sdk/react'
import { PropertyContainer } from '@salsita-ai/platform-project-sdk/ui'

const warmingDrawerPowderCoatingTitle = msg({ message: 'Warming Drawer Powder Coating' })
const grillPowderCoatingTitle = msg({ message: 'Grill Powder Coating' })
const powderCoatingDescription = msg({ message: 'Match front panel cover with cabinets' })

const LynxProfessionalGrillPropertyPage = (props: { id: Model.LynxProfessionalGrill['id'] }) => {
  const { id } = props

  if (
    Model.LynxProfessionalGrillW30.isId(id) ||
    Model.LynxProfessionalGrillW36.isId(id) ||
    Model.LynxProfessionalGrillW42.isId(id)
    // LynxProfessionalGrillW54: doesn't have any variants
  ) {
    return (
      <PropertyContainer.Item title={<Trans>Variant</Trans>}>
        <AttributeListSelector entityId={id} instanceName="variant" />
      </PropertyContainer.Item>
    )
  }

  return null
}

const LynxSedonaGrillPropertyPage = (props: { id: Model.LynxSedonaGrill['id'] }) => {
  const { id } = props

  return (
    <PropertyContainer.Item title={<Trans>Variant</Trans>}>
      <AttributeListSelector entityId={id} instanceName="variant" />
    </PropertyContainer.Item>
  )
}

interface GrillBasePropertyPageProps {
  applianceId: Model.Appliance['id'] | null
  warmingDrawerId: Model.GrillBase['warmingDrawerId'] | null
  cabinetId: Model.BottomCabinet['id']
}

export const GrillBasePropertyPage = (props: GrillBasePropertyPageProps) => {
  const { applianceId, cabinetId, warmingDrawerId } = props
  const isApplianceWithPowderCoating = applianceId && Model.ApplianceWithPowderCoating.isId(applianceId)

  const resolveLocalizable = useResolveLocalizable()

  return (
    <PropertyContainer.Group spacing="large">
      {applianceId && Model.LynxProfessionalGrill.isId(applianceId) && (
        <LynxProfessionalGrillPropertyPage id={applianceId} />
      )}

      {isApplianceWithPowderCoating && (
        <AttributeSwitchSelector
          entityId={applianceId}
          instanceName="powderCoating"
          title={resolveLocalizable(grillPowderCoatingTitle)}
          description={resolveLocalizable(powderCoatingDescription)}
        />
      )}

      {applianceId && Model.LynxSedonaGrill.isId(applianceId) && <LynxSedonaGrillPropertyPage id={applianceId} />}
      <PropertyContainer.Item title={<Trans>Warming Drawer</Trans>}>
        <AttributeListSelector entityId={cabinetId} instanceName="variant" />
      </PropertyContainer.Item>

      {warmingDrawerId && (
        <AttributeSwitchSelector
          entityId={warmingDrawerId}
          instanceName="powderCoating"
          title={resolveLocalizable(warmingDrawerPowderCoatingTitle)}
          description={resolveLocalizable(powderCoatingDescription)}
        />
      )}
    </PropertyContainer.Group>
  )
}
